// SUB-OFFICE 7 — DIRECT VOICE (the soul of the Machine Floor, M-D).
//
// The entire building above speaks in the THIRD person: the Registrar judges
// OFFERINGS, in memo/chyron/stamp, ALL CAPS, housed, procedural. Down on Floor
// -1 that register BREAKS — the building drops the memo format and says "you",
// in sentence case, unhoused, once at a time. DirectVoice is the channel for
// that break: typographically the OPPOSITE of the chyron's boxed amber
// ALL-CAPS — a LOW, WIDE, UNBOXED caption, bottom-center, warm amber on the
// dark, sentence case, tight letter-spacing. The memo with the housing torn off.
//
// It is a screen-space DOM overlay (a caption, not geometry) so its 1.6m
// readability is guaranteed regardless of where the player looks — a deliberate,
// noted deviation from a world-space mesh: bottom-center legibility is the
// point, and the cab voice + dom.say already establish the DOM-caption idiom.
// One <div>, no external assets, disposed on teardown. Reduced-motion prints
// instantly and holds; motion fades in/out over ~0.9s.

const AMBER = '#d99321'; // PAL.amber — the Machine's voice, the only warm pixels below

export class DirectVoice {
  private root: HTMLDivElement;
  private hideTimer = 0;
  private mounted = false;

  constructor(private reducedMotion: boolean) {
    const el = document.createElement('div');
    el.setAttribute('data-directvoice', '');
    el.setAttribute('aria-live', 'polite');
    el.style.cssText =
      'position:fixed;left:8%;right:8%;bottom:11%;z-index:9990;pointer-events:none;' +
      'text-align:center;color:' + AMBER + ';' +
      // sentence case, unboxed, tight tracking — NOT the chyron's caps mono box
      "font-family:Georgia,'Times New Roman',serif;font-size:min(3.4vh,26px);" +
      'line-height:1.42;letter-spacing:-0.006em;font-weight:400;' +
      'text-shadow:0 1px 14px rgba(0,0,0,0.85),0 0 30px rgba(217,147,33,0.14);' +
      'opacity:0;transition:opacity ' + (reducedMotion ? '0s' : '0.9s') + ' ease;' +
      'text-wrap:balance;max-width:60ch;margin:0 auto';
    this.root = el;
  }

  /** Print one line, unhoused, and hold it for `holdS` seconds, then fade out.
   *  Sentence case is preserved verbatim — this is the ONLY lowercase text in
   *  the entire building; never uppercased. */
  speak(line: string, holdS = 7): void {
    if (!this.mounted) { document.body.appendChild(this.root); this.mounted = true; }
    this.root.textContent = line;
    // force reflow so the opacity transition re-triggers on a repeated show
    void this.root.offsetWidth;
    this.root.style.opacity = '1';
    this.hideTimer = holdS;
  }

  update(dt: number): void {
    if (this.hideTimer > 0) {
      this.hideTimer -= dt;
      if (this.hideTimer <= 0) { this.root.style.opacity = '0'; this.hideTimer = 0; }
    }
  }

  /** Instant hide (e.g. entering a maintenance runner overlay). */
  clear(): void { this.root.style.opacity = '0'; this.hideTimer = 0; }

  dispose(): void {
    this.hideTimer = 0;
    if (this.mounted) { this.root.remove(); this.mounted = false; }
  }
}
